/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineConfigurationEntry {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineConfigurationEntry.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineConfigurationEntry>): AIUnitEconomicsBaselineConfigurationEntry {
        let obj = Object.assign(new AIUnitEconomicsBaselineConfigurationEntry(), model);
        AIUnitEconomicsBaselineConfigurationEntry.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineConfigurationEntry>): AIUnitEconomicsBaselineConfigurationEntry {
        if (!model) return null;
        return AIUnitEconomicsBaselineConfigurationEntry.newInstance(<AIUnitEconomicsBaselineConfigurationEntry> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineConfigurationEntry) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineConfigurationEntry.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineConfigurationEntry): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineConfigurationEntry.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.manual_process_duration === undefined) {
            this.manual_process_duration = 0;
        }
        if (this.ai_execution_duration === undefined) {
            this.ai_execution_duration = 0;
        }
        if (this.manual_quality_score === undefined) {
            this.manual_quality_score = 0;
        }
        if (this.ai_quality_score === undefined) {
            this.ai_quality_score = 0;
        }
        if (this.value_realized === undefined) {
            this.value_realized = 0;
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Value of the baseline's primary_key column for this entry; must be unique within the baseline
     */
    primary_key_value: string;

    /**
     * Tags from the 'tag.<name>' columns, used to consolidate cost further (owner, business unit, application, ...). Never used to match cost
     */
    tags: Array<models.KeyValuePair>;

    /**
     * Free-text classification of what this workload does
     */
    usecase_category: string;

    /**
     * Duration the equivalent manual process took, in the baseline's duration_unit
     */
    manual_process_duration: number;

    /**
     * Duration the AI workload takes, in the baseline's duration_unit
     */
    ai_execution_duration: number;

    /**
     * Quality of the manual process on the baseline's quality_scale. Null means not measured
     */
    manual_quality_score: number;

    /**
     * Quality of the AI workload on the baseline's quality_scale. Null means not measured
     */
    ai_quality_score: number;

    /**
     * Business value attributed to this workload, in the tenant's configured currency. Null means not measured
     */
    value_realized: number;

}
